// extracted by mini-css-extract-plugin
export var label = "_ii-0";
export var treatmentCard = "_ii-1";